import FastJobDialogs from '@/weon/models/FastJobDialogs';

const state = new FastJobDialogs();

export default state;
